module.exports = "<div class=\"page\">\r\n  <environment-bar></environment-bar>\r\n  <div class=\"redirect-background\">\r\n    <div class=\"top-pad\"></div>\r\n    <div class=\"redirect-box\">\r\n      <div class=\"panel content\">\r\n        <div class=\"redirect-title\">\r\n          You are being redirected\r\n        </div>\r\n        <div class=\"redirect-text\">\r\n          Please wait while we transfer you\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"bot-pad\"></div>\r\n  </div>\r\n  <aemo-footer></aemo-footer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/views/redirect.html
// module id = 441
// module chunks = 0